<template>
    <div class="card">
        <div class="card-header bg-white">
            <h5 class="me-auto">Listado</h5>
        </div>
        <div class="card-body p-0">
            <template>
                <v-data-table  class="elevation-1 no-hover"
                    :items="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear' ? [] :items.data"
                    :options.sync="options"
                    :server-items-length="items.total"
                    :loading="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear'"
                    hide-default-header
                    :footer-props="{
                        'items-per-page-options': [5, 10, 50, 100]
                    }">
                    <template v-slot:[`item`]="{ item, index }">
                        <tr colspan="100%">
                            <div class="container-fluid py-4" :class="index < (items.data.length - 1) ? 'border-bottom' : ''">
                                <div class="row">
                                    <div class="col-12">
                                        <v-tooltip bottom class="mx-1">
                                            <template v-slot:activator="{ on, attrs }">
                                                <b v-bind="attrs" v-on="on" v-if="Array.isArray(item.description)">
                                                    {{ item.description[0] }}
                                                </b>
                                            </template>
                                            <small><div v-for="(description, key) in  item.description" :key="key">{{ description }}</div></small>
                                        </v-tooltip>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group mb-2">
                                            <small class="input-title">{{ item.type }}</small>
                                            <label class="form-control form-control-sm text-muted bg-white">
                                                <router-link :to="{ name: 'PackageDetail', params: { id: item.id }}" class="text-decoration-none">
                                                    {{`${item.type}${item.id}`}}
                                                    <i class="fa-solid fa-square-arrow-up-right"></i>
                                                </router-link>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <small class="input-title">Peso</small>
                                        <label class="form-control form-control-sm text-muted bg-white">
                                            {{ Number(String(item.weight)).toFixed(2) }}
                                        </label>
                                    </div>
                                    <div class="col-12"></div>
                                    <div class="col-md-6">
                                        <div class="form-group mb-2">
                                            <small class="input-title">Impuesto</small>
                                            <search-tax v-model="item.tax_id" :tax="item.tax"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group mb-2">
                                            <small class="input-title">Cliente</small>
                                            <search-user v-model="item.user" @set_value="e => item.user_id = e"/>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group mb-2">
                                            <small class="input-title">Valor</small>
                                            <div class="input-group input-group-sm mb-2">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i class="bi bi-currency-dollar"></i></span>
                                                </div>
                                                <input type="text" v-model="item.value" class="form-control form-control-sm" placeholder="0.00" @keypress="DOUBLE">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group mb-2">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="CALCULATE(item)"
                                                        type="button" v-bind="attrs" v-on="on"
                                                        class="btn btn-primary btn-h w-100" :disabled="!item.value || !item.tax_id">
                                                        <div class="spinner-border spinner-border-sm" role="status" v-if="calculate.filter(e => e == item.id).length == 1">
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                        <span v-else><i class="bi bi-calculator"></i></span>
                                                    </button>
                                                </template>
                                                <small>Calcular</small>
                                            </v-tooltip>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group mb-3">
                                            <small class="input-title">Precio</small>
                                            <div class="input-group input-group-sm mb-2">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i class="bi bi-currency-dollar"></i></span>
                                                </div>
                                                <input type="text" v-model="item.subtotal" class="form-control form-control-sm" placeholder="0.00" @keypress="DOUBLE">
                                                <div class="input-group-append">
                                                    <button type="button" class="btn btn-success btn-m" @click="ADD_LINE(item)">
                                                        <i class="bi bi-plus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="row mb-2" v-for="(bill, i) in item.invoice_items" :key="i">
                                                <div class="input-group input-group-sm col pl-0">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i class="bi bi-currency-dollar"></i></span>
                                                    </div>
                                                    <input type="text" v-model="bill.value" class="form-control form-control-sm" placeholder="0.00" @keypress="DOUBLE">
                                                </div>
                                                <div class="input-group input-group-sm col pr-0">
                                                    <input type="text" v-model="bill.description" class="form-control form-control-sm" placeholder="Descripción">
                                                    <div class="input-group-append">
                                                        <button type="button" class="btn btn-danger btn-m" @click="REMOVE(item, i)">
                                                            <i class="bi bi-x"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group mb-2">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="CONFIRM(item)"
                                                        :disabled="!item.subtotal" type="button" v-bind="attrs" v-on="on"
                                                        class="btn btn-success btn-h w-100">
                                                        <div class="spinner-border spinner-border-sm" role="status" v-if="confirm.filter(e => e == item.id).length == 1">
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                        <span v-else><i class="fa fa-save"></i>+ <i class="bi bi-check-lg"></i></span>
                                                    </button>
                                                </template>
                                                <small>Confirmar</small>
                                            </v-tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </tr>
                    </template>
                </v-data-table>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    props: ['items', 'loading', 'calculate', 'confirm'],
    data(){
        return{
            expanded: [],
            options: {},
        }
    },
    methods: {
        CALCULATE: function(item){
            this.$emit('on_calculate', item)
        },
        ADD_LINE: function(item){
            this.$emit('add_line', item)
        },
        REMOVE: function(item, index){
            this.$emit('remove_line', item, index)
        },
        CONFIRM: function(item){
            this.$emit('on_confirm', item)
        }
    },
    watch: {
        options: {
            handler(e) {
                this.$emit('options', e)
            },
            deep: true
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/packages/table/list-task.vue